import {Environment} from '../environment';
import {PROXY_PORTS} from './constants';
import {HttpUrl} from './types';

export const tadaridaUrlByEnvironment: Record<Environment, HttpUrl> = {
  production: 'https://tadarida-web.aboutyou.com',
  preview: 'https://tadarida-preview-web.aboutyou.com',
  staging: 'https://tadarida-web.aboutyou-staging.com',
  development: `http://localhost:${PROXY_PORTS.TADARIDA_PORT}` as HttpUrl,
};

const tadaridaInternalServerUrlReplacements: Record<Environment, HttpUrl> = {
  production: 'https://tadarida-web-internal.aboutyou.com',
  preview: 'https://tadarida-preview-web.aboutyou.com',
  staging: 'https://tadarida-web-internal.aboutyou-staging.com',
  development: tadaridaUrlByEnvironment.development,
};

export const getTadaridaInternalUrlReplacements = (environment: Environment) =>
  process.env.NODE_ENV === 'test'
    ? tadaridaUrlByEnvironment.development
    : tadaridaInternalServerUrlReplacements[environment];

export const gripsUrlByEnvironment: Record<Environment, HttpUrl> = {
  production: 'https://grips-web.aboutyou.com',
  preview: 'https://grips-web.aboutyou.com',
  staging: 'https://grips-web.aboutyou-staging.com',
  development: `http://localhost:${PROXY_PORTS.GRIPS_PORT}` as HttpUrl,
};

const gripsInternalServerUrlReplacements: Record<Environment, HttpUrl> = {
  production: 'https://grips-web-internal.aboutyou.com',
  preview: 'https://grips-web-internal.aboutyou.com',
  staging: 'https://grips-web-internal.aboutyou-staging.com',
  development: gripsUrlByEnvironment.development,
};

export const getGripsInternalUrlReplacements = (environment: Environment) =>
  gripsInternalServerUrlReplacements[environment];
